
<script>
import {
  trackAudioCheckMap,
  audioCheckErrorMap,
} from '@/utils/constants'

const errorCodes = Object.keys(audioCheckErrorMap)

export default {
  name: 'AudioCheckIcon',
  props: {
    track: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const { disabled } = this.$props
    // const h = this.$createElement
    const trackObj = this.track
    const errorList = []
    const normalList = []
    let content = ''
    let iconClass = ''
    const error = []
    const fileCheck = trackObj.fileCheck

    if (fileCheck === '0') {
      // 无音频问题
      iconClass = 'el-icon-success'
      content = '无音频问题'
    } else {
      // 生成的正则: /^(code|code|...|code)$/
      const errorReg = new RegExp(`^(${errorCodes.join('|')})$`, '')
      const fileCheckList = fileCheck.split(',')
      // console.log(errorReg)
      for (const code of fileCheckList) {
        if (errorReg.test(code)) {
          // 严重问题
          errorList.push(<div>{`${code} - ${trackAudioCheckMap[code]}`}</div>)
        } else {
          // 中等问题
          normalList.push(<div>{`${code} - ${trackAudioCheckMap[code]}`}</div>)
        }
      }

      if (errorList.length) {
        error.push('严重音频问题：')
        error.push(...errorList)
      }
      if (normalList.length) {
        error.push('一般音质问题：')
        error.push(...normalList)
      }
      iconClass = errorList.length ? 'el-icon-warning' : 'el-icon-info'
    }

    return (
      <el-tooltip placement="top" disabled={ disabled }>
        <div slot="content">{ content }{ error }</div>
        <i class={iconClass} />2342
      </el-tooltip>
    )
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.el-icon-warning {
  color: $danger;
}
.el-icon-info {
  color: $warning;
}
.el-icon-success {
  color: $success;
}
</style>
